import styled from "styled-components";
import css from "@styled-system/css";
import { LayoutProps } from "styled-system";

import Card from "../Card/Card";
import Typography from "../Typography/Typography";
import Button from "../Button/Button";

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  margin: 0;
  ${css({
    m: 0,
  })}
`;

interface CardContent {
  headline: string;
  description: string;
  moreInfo?: {
    label: string;
    visible: boolean;
  };
  width?: LayoutProps["width"];
  height?: LayoutProps["height"];
}

export default function CardWithNoImage({
  headline,
  description,
  moreInfo,
  width = 300,
  height = "100%",
}: CardContent) {
  return (
    <StyledCard
      width={width}
      height={height}
      aria-label="card with no image"
      variant="hoverable"
    >
      <Typography variant="h5" textAlign="left" color="text-color" m={0}>
        {headline}
      </Typography>
      <Typography
        variant="body"
        color="lighter-text-color"
        textAlign="left"
        p={0}
        mt={2}
        mb={moreInfo && moreInfo.visible ? 4 : 0}
        css={`
          line-height: 1.36;
          min-height: 57px;
        `}
      >
        {description}
      </Typography>
      {moreInfo && moreInfo.visible && (
        <Button
          variant="tertiary"
          text={moreInfo.label}
          width="fit-content"
          height="fit-content"
          textAlign="start"
          p={0}
          mt="auto"
        />
      )}
    </StyledCard>
  );
}
